import React from "react";
import sanjeevniApartmentsImg from "../../assets/images/webp/other/sanjeevni-apartments-img.webp";
import { PROJECTS_LIST } from "../../utils/other-component";
import Icons from "../common/components/Icons";
import BlueTag from "../common/ui/BlueTag";
import Heading from "../common/ui/Heading";
import Paragraph from "../common/ui/Paragraph";

const KeyProjects = () => {
  return (
    <>
      <div className="py-[140px] px-4 max-xl:py-[120px] max-lg:py-24 max-md:py-20 max-sm:py-10">
        <div className="flex items-center justify-center flex-col pb-10 max-md:pb-6">
          <BlueTag className="mt-1" center>
            Features
          </BlueTag>

          <Heading className="max-w-[864px] mx-auto text-center mt-1">
            Key Projects
          </Heading>
        </div>
        <div className="flex items-center max-w-[1140px] max-md:flex-wrap max-md:justify-center gap-6 mx-auto">
          {PROJECTS_LIST.map((obj, i) => (
            <div
              key={i}
              className="p-[1px] w-full max-w-[558px] h-[624px] max-lg:h-[640px] max-md:h-full rounded-2xl projects-box-bg border border-solid border-transparent shadow-[0px_4px_17.7px_0px_#0000001A]"
            >
              <div className="w-full bg-[#FEFEFE] h-full p-4 rounded-2xl">
                <img
                  src={obj.img}
                  alt="projects"
                  width={526}
                  height={272}
                  className="w-full max-w-[526px] rounded-[6px]"
                />
                <h2 className="text-xl font-bold leading-[150%] ff-jakarta text-[#001A3D] pt-[25px]">
                  {obj.title}
                  <span className="font-normal">{obj.subTitle}</span>
                </h2>

                <Paragraph className="pt-[13px]"> {obj.description}</Paragraph>
                <div className="flex items-center gap-1.5 pt-5">
                  <Icons icon="CheckIcon" />{" "}
                  <p className="text-[#001A3D] font-semibold text-sm leading-[19.34px] ">
                    {obj.listOne}
                  </p>
                </div>
                <div className="flex items-center gap-1.5 py-4">
                  <Icons icon="CheckIcon" />{" "}
                  <p className="text-[#001A3D] font-semibold text-sm leading-[19.34px] ">
                    {obj.listTwo}
                  </p>
                </div>
                <div className="flex items-center gap-1.5">
                  <Icons icon="CheckIcon" />{" "}
                  <p className="text-[#001A3D] font-semibold text-sm leading-[19.34px] ">
                    {obj.listThree}
                  </p>
                </div>
                <Paragraph className="pt-5"> {obj.descriptionTwo}</Paragraph>
              </div>
            </div>
          ))}
        </div>
        <div className="rounded-2xl mt-6 mx-auto projects-box-bg border p-[1px] border-solid border-transparent shadow-[0px_4px_17.7px_0px_#0000001A] w-full max-w-[1140px]">
          <div className="bg-white rounded-2xl p-4 max-lg:flex-wrap max-xl:gap-8 max-md:gap-6 flex items-center gap-[61px]">
            <img
              src={sanjeevniApartmentsImg}
              alt="projects"
              width={493}
              height={333}
              className="w-full max-w-[493px] max-lg:max-w-full pointer-events-none"
            />
            <div className="w-full max-w-[545px]">
              <h2 className="text-xl font-bold leading-[150%] ff-jakarta text-[#001A3D]">
                krishna apartment <span>(Khatu Shyam Ji)</span>
              </h2>
              <Paragraph>
                A spiritual real estate landmark near the famous Khatu Temple.
                These apartments were created to serve devotees and families
                looking for peaceful living near sacred energy.
              </Paragraph>
              <Paragraph className="pt-3 sm:pt-5">
                Blending modern living with spiritual surroundings, these
                apartments are a reflection of Deepak Sharma's heart-centered
                vision.
              </Paragraph>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KeyProjects;
